import { Image } from "@wss/image";
import ct from "class-types.macro";
import React from "react";
import { BannerItem } from "../HomePageResult";
import { trackClickThroughStats } from "~/userAnalytics";
import { usePromotionTracking, handlePromotionClick } from "../../Gtm/usePromotionTracking";
interface HomePageBannerItemProps {
  hidden: boolean;
  id: string;
  bannerItem: BannerItem;
  groupAriaLabel: string;
  className?: string;
  position: number;
}
const HomePageBannerItem = ({
  hidden,
  id,
  bannerItem,
  groupAriaLabel,
  position
}: HomePageBannerItemProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  usePromotionTracking(containerRef);
  const itemClasses = `${ct("items-center", "justify-center", "flex-none", "max-w-full", "min-h-full", "min-w-full", hidden ? "hidden" : "inline-flex")} inner-banner`;
  const large = bannerItem.images.find(x => x.sizeSuffix === "lg")?.imagePath;
  const medium = bannerItem.images.find(x => x.sizeSuffix === "md")?.imagePath;
  const small = bannerItem.images.find(x => x.sizeSuffix === "sm")?.imagePath;
  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    trackClickThroughStats(e);
    handlePromotionClick(e);
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div role="tabpanel" aria-label={groupAriaLabel} className={itemClasses} id={id} data-testid="bannerItem" ref={containerRef} data-sentry-component="HomePageBannerItem" data-sentry-source-file="HomePageBannerItem.tsx">
      <a href={bannerItem.url} aria-label={bannerItem.altText} className={ct("text-white", "w-full", "gtm-promo")} data-ctt="1" data-ctd={bannerItem.bannerId} data-id={bannerItem.bannerId} data-name={bannerItem.altText} data-position={position} data-isbanner onClick={handleClick}>
        <picture data-alt={bannerItem.altText} className="flex" data-sentry-element="picture" data-sentry-source-file="HomePageBannerItem.tsx">
          <source media="(max-width: 599px)" srcSet={small} width={5} height={4} />
          <source media="(min-width: 600px) and (max-width: 1499px)" srcSet={medium} width={180} height={49} />
          <Image className="b-loaded w-full h-auto" fetchpriority={position === 1 ? "high" : "low"} alt={bannerItem.altText} src={large} width={1721} height={469} data-sentry-element="Image" data-sentry-source-file="HomePageBannerItem.tsx" />
        </picture>
      </a>
    </div>
  );
};
export default HomePageBannerItem;